import { TFunction } from 'i18next';
import * as Yup from 'yup';

export const loginSendEmailSchema = (t: TFunction) => Yup.object({
  email: Yup.string()
    .required(t('onboarding.login.verifyCode.yupSchema.email_validation'))
    .email(t('onboarding.login.verifyCode.yupSchema.require')),
});
